export const isJsonString = (input: string | undefined): boolean => {
    if (!input) {
        return false;
    }
    try {
        JSON.parse(input);
    } catch {
        return false;
    }

    return true;
};
